import { render, staticRenderFns } from "./Qualifications.vue?vue&type=template&id=05de56f3&scoped=true&"
import script from "./Qualifications.vue?vue&type=script&lang=js&"
export * from "./Qualifications.vue?vue&type=script&lang=js&"
import style0 from "./Qualifications.vue?vue&type=style&index=0&id=05de56f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05de56f3",
  null
  
)

export default component.exports